import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { HelperService } from 'src/app/services/shared/helper/helper.service';
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public faEyeSlash = faEyeSlash;
  public faEye = faEye;
  public isSubmitted = false;
  public showPassword = false;

  constructor(private _helper: HelperService, private _router: Router, private _fb: FormBuilder, private _authService: AuthenticationService) { }

  formLogin: FormGroup;

  ngOnInit() {
    this.createForm();
  }

  createForm(){
    this.formLogin = this._fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  onSubmit(){
    this.isSubmitted = true;
    if(this.formLogin.invalid){return}
    this._authService.login(this.formLogin.value).subscribe(res => {
      if(res && res['user']){
        this._helper.user.set(res['user']);
      }
      if(res && res['refreshToken']){
        this._helper.refreshToken.set(res['refreshToken']);
      }
      if(res && res['token']){
        this._helper.token.set(res['token']);
        this._router.navigate(["./landing/customer-list"]);
      }
    });
  }

  togglePasswordVisibility(param: boolean){
    this.showPassword = param;
  }

  get f(){
    return this.formLogin.controls;
  }

}
